import { last } from 'lodash';
import { useEffect } from 'react';
import { CgmBrandEnum, CgmDeviceStatusEnum, useCgmGetPatientCgmDevice } from '../../../../uc-api-sdk';
import { CGMDeviceAccountLinkingComponent, CGMDeviceAccountLinkingComponentProps } from '../../component/CGMDeviceAccountLinkingComponent/CGMDeviceAccountLinkingComponent';
import { useCGMDeviceContext } from '../CGMDeviceContainer/CGMDeviceContainer';
import { useUpdateListener } from '../../../../contexts/UpdateContext/UpdateContext';

export interface CGMDeviceAccountLinkingContainerProps
  extends CGMDeviceAccountLinkingComponentProps {
  onChange?: (value?: CgmDeviceStatusEnum) => void;
}

export const CGMDeviceAccountLinkingContainer = ({
  patientId,
  brand,
  model,
  onChange,
}: CGMDeviceAccountLinkingContainerProps) => {
  const cgmDeviceContext = useCGMDeviceContext();
  const info = useCgmGetPatientCgmDevice({
    params: { patientId, request: { brandIn: [brand] } },
    options: { sendOnMount: !cgmDeviceContext && !!patientId },
  });

  const patientCGMDeviceInfo = (
    cgmDeviceContext?.patientCGMDeviceLinkStatusInfo || info
  );
  const patientCGMDevices = patientCGMDeviceInfo?.data?.data;

  const fetchNewStatus = async (brand: CgmBrandEnum) => {
    let newStatus: CgmDeviceStatusEnum | undefined;
    if (cgmDeviceContext) {
      const res = await cgmDeviceContext?.getPatientCGMDeviceLinkStatusByBrand(brand);
      newStatus = last(res?.data || [])?.status ?? undefined;
    } else {
      const res = await patientCGMDeviceInfo.send({
        params: {
          patientId, request: { brandIn: [brand] }
        }
      });
      newStatus = last(res?.data || [])?.status ?? undefined;
    }
    onChange?.(newStatus);
  };
  useUpdateListener('CGM_LINKING_UPDATED', () => fetchNewStatus(brand));

  useEffect(() => {
    fetchNewStatus(brand);
  }, [brand]);

  return (
    <CGMDeviceAccountLinkingComponent
      patientId={patientId}
      linkingStatus={last(patientCGMDevices)}
      brand={brand}
      model={model}
    />
  );
};
